module.exports = __webpack_public_path__ + "img/12.0a48c188.png";